// extracted by mini-css-extract-plugin
export var avatar = "_lv-3";
export var avatarContainer = "_lv-2";
export var avatarSpacer = "_lv-5";
export var avatarSpacerContainer = "_lv-4";
export var avatarStackContainer = "_lv-1";
export var bubble = "_lv-0";
export var remainderBubble = "_lv-6";